import React, { useState } from "react";
import { openIntercomMessenger } from "../../itrust_common/utils/intercomMessenger";
import Toastr from "../../itrust_common/components/Toastr";

const MainPopup = (props) => {
  const { setView, handleOnboardingTourReplay } = props;
  const [openingIntercom, setOpeningIntercom] = useState(false);

  const handleOpenIntercom = async () => {
    if (openingIntercom) return;

    setOpeningIntercom(true);
    try {
      await openIntercomMessenger();
      setView(false);
    } catch (error) {
      console.error("Intercom Messenger failed to open", error);
      Toastr.handleShow(false, "Unable to open live chat. Please try again.");
    } finally {
      setOpeningIntercom(false);
    }
  };

  return (
    <div className="">
      <ul className="position-absolute bg-white main-popup  text-center text-gray2 text-sm rounded-lg shadow-lg z-50 list-unstyled bg-clip-padding  mt-1 border border-1 border-gray m-0">
        <li
          className={`border-bottom border-gray2 cursor-pointer ${
            openingIntercom && "active-record"
          }`}
          onClick={handleOpenIntercom}
        >
          <p className="dropdown-item py-5 px-3 mb-0 font-normal text-gray-700 hover-effect">
            <i className="las la-comments text-primary"></i>
            <br />
            {openingIntercom ? "Opening" : "Live"} <br /> Chat
          </p>
        </li>
        <li>
          <span className="dropdown-item text-sm py-5 px-3 text-gray-700 hover-effect pointer" onClick={handleOnboardingTourReplay}>
            <i className="las la-hand-pointer text-primary"></i><br />
            App Tour
          </span>
        </li>
      </ul>
    </div>
  );
};

export default MainPopup;
